import BaseApi from '@/services/api/base.api'

class ArtistApi extends BaseApi {
  async selectArtistInfo(): Promise<IArtistInfoSelect.ResponseItem> {
    const response: IArtistInfoSelect.Response =
      await this.app.$fetchService.get(
        `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/simple`,
      )

    return response.success
  }

  async selectEntryStatus(): Promise<IArtistEntryStatusSelect.ResponseItem> {
    const response: IArtistEntryStatusSelect.Response =
      await this.app.$fetchService.get(
        `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/status`,
      )

    return response.success
  }

  async selectArtistApply(): Promise<IArtistApplySelect.Response> {
    return this.app.$fetchService.get(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist`,
    )
  }

  async updateArtistSave(item: IArtistSaveUpdate.Request): Promise<void> {
    return this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist`,
      {
        ...item,
      },
    )
  }

  async selectArtistApplyProduct(): Promise<IArtistApplyProductSelect.Response> {
    return this.app.$fetchService.get(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/product`,
    )
  }

  async updateArtistProductSave(
    item: IArtistSaveProductUpdate.Request,
  ): Promise<void> {
    return this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/product`,
      {
        ...item,
      },
    )
  }

  async updateValidateBusinessNumber(
    item: IArtistValidateBusinessNumberUpdate.Request,
  ): Promise<IArtistValidateBusinessNumberUpdate.Response> {
    return this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/business/validate`,
      {
        ...item,
      },
    )
  }

  async updateArtisApplySubmit(): Promise<void> {
    return this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/submit`,
    )
  }
}

export default ArtistApi
